<div class="tracked-pairs-edit-section">
  @if (isLoading) {
    <div class="loading-container">
      <app-loader></app-loader>
      <p>Loading monitored pairs...</p>
    </div>
  }

  @if (loadError) {
    <div class="error-container">
      <mat-icon class="error-icon">error</mat-icon>
      <p class="error-message">{{ loadError }}</p>
      <button mat-raised-button color="primary" type="button" (click)="retryLoadData()">Retry</button>
    </div>
  }

  @if (!isLoading && !loadError) {
    <div class="pairs-list">
      @if (trackedPairs.length > 0) {
        @for (pair of trackedPairs; track pair.id) {
          <div class="pair-row">
            <div class="pair-content">
              <span class="pair-type">{{ getSourceTypeLabel(pair.sourceType) }}</span>
              <span class="pair-name" [class.missing-ref]="isSourceMissing(pair)">{{ getSourceDisplayName(pair) }}</span>
              <span class="pair-arrow">→</span>
              <span class="pair-name" [class.missing-ref]="isGoalMissing(pair.goalId)">{{ getGoalDisplayName(pair.goalId) }}</span>
            </div>
            <div class="table-actions">
              <mat-icon
                [class.disabled]="deletingIds.has(pair.id)"
                (click)="deleteTrackedPair(pair)">
                delete
              </mat-icon>
            </div>
          </div>
        }
      } @else {
        <p class="empty-state">No monitored pairs configured.</p>
      }
    </div>

    <div class="add-row">
      <mat-form-field class="source-type-field">
        <mat-label>Source Type</mat-label>
        <mat-select
          [(ngModel)]="selectedSourceType"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="isAdding"
          (ngModelChange)="onSourceTypeChange()">
          @for (option of sourceTypeOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (selectedSourceType === TrackedPairsSourceType.Audience) {
        <mat-form-field class="entity-field">
          <mat-label>Audience</mat-label>
          <mat-select
            [(ngModel)]="selectedAudienceId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isAdding">
            @for (audience of audiences; track audience.id) {
              <mat-option [value]="audience.id">{{ audience.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <mat-form-field class="entity-field">
          <mat-label>Segment</mat-label>
          <mat-select
            [(ngModel)]="selectedSegmentId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isAdding">
            @for (segment of segments; track segment.segmentId) {
              <mat-option [value]="segment.segmentId">{{ segment.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field class="entity-field">
        <mat-label>Goal</mat-label>
        <mat-select
          [(ngModel)]="selectedGoalId"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="isAdding">
          @for (goal of goals; track goal.id) {
            <mat-option [value]="goal.id">{{ goal.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button
        class="app-rounded-btn add-button"
        type="button"
        [disabled]="!canAdd"
        (click)="addTrackedPair()">
        {{ isAdding ? 'Adding...' : 'Add' }}
      </button>
    </div>
  }
</div>
